module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Credit-card-c36abdbd1db8c04f2654f75e102b8b32.svg";